// Feb 2026 · Cycle 63 · Tiny wrapper around canvas-confetti so we can
// fire a warm "welcome" burst from anywhere without duplicating the
// import + tuning. Falls silently on server / test environments.
import confetti from "canvas-confetti";

const PALETTE = ["#FFB49A", "#A5E6C6", "#FF8A80", "#FBBF77", "#7CD5FF", "#FFF0B3"];

/** A joyful two-burst welcome celebration. */
export function celebrate(opts = {}) {
  try {
    const defaults = {
      spread: 70,
      colors: PALETTE,
      startVelocity: 40,
      ticks: 200,
      scalar: 1.1,
      disableForReducedMotion: true,
    };
    // Left burst.
    confetti({ ...defaults, particleCount: 60, origin: { x: 0.2, y: 0.55 }, angle: 60, ...opts });
    // Right burst — small delay for a natural two-hand feel.
    setTimeout(() => {
      confetti({ ...defaults, particleCount: 60, origin: { x: 0.8, y: 0.55 }, angle: 120, ...opts });
    }, 220);
    // Center rain a moment later.
    setTimeout(() => {
      confetti({ ...defaults, particleCount: 80, origin: { x: 0.5, y: 0.3 }, spread: 120, startVelocity: 30, ...opts });
    }, 480);
  } catch { /* ignore */ }
}
